import React, { useState, useEffect, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import httpClient from "../../lib/HttpClient";
import notificationIndicator from "../../images/icons/svg/notification-indicator.png";
import styles from "./DashboardCommentCard.module.scss";
import Lottie from "react-lottie";
import loadingAnimation from "../../images/lotties/loading.json";
import close from "../../images/icons/svg/close-grey.svg";
import "./Animation.css";
import { CSSTransition } from "react-transition-group";
import fetchDashboardData from "../../actions/Dashboard/fetchDashboardData";

export default (props) => {
  const {
    comments,
    setComments,
    setShowConversationPanel,
    setSelectedComment,
    setShowDashboardPreviewModal,
    setSelectedPreview,
    setConversationPreview,
    showLoader,
  } = props;

  const [elRefs, setElRefs] = useState([]);
  const [dismissed, setDismissed] = useState(null);

  const dispatch = useDispatch();

  const boundActionCreators = bindActionCreators(
    {
      fetchDashboardData,
    },
    dispatch
  );

  useEffect(() => {
    if (comments && comments.length > 0) {
      let refs = [];
      comments.map((link, index) => {
        refs.push(createRef());
      });
      setElRefs(refs);
    }
  }, [comments]);

  const updateComments = (index) => {
    let updatedComments = [...comments];
    updatedComments.splice(index, 1);
    let updatedRefs = [...elRefs];
    updatedRefs.splice(index, 1);
    setElRefs(updatedRefs);
    setComments(updatedComments);
  };

  const dismissConversation = (conversation, index) => {
    setDismissed(elRefs[index]);
    let url = `/conversations/dismiss/${conversation.id}.json`;
    httpClient.put(url).then((res) => {
      setTimeout(() => updateComments(index), 300);
    });
  };

  const formatMentions = (text) => {
    const mention = new RegExp("{{(.*?)}}", "gi");
    const parts = text ? text.split(mention) : [];

    return (
      <span>
        {" "}
        {parts.map((part, i) => {
          return <span key={i}>{part}</span>;
        })}{" "}
      </span>
    );
  };

  const toggleConversationStatus = (conversation, index) => {
    setDismissed(elRefs[index]);
    let url = `/conversations/${
      conversation.xfdf_highlight_id
        ? conversation.xfdf_highlight_id
        : conversation.block_identifier
    }.json`;
    httpClient
      .put(url, {
        conversation: {
          status: "resolved",
        },
      })
      .then((res) => {
        setTimeout(() => updateComments(index), 300);
      });
  };

  const replyInConversation = (comment) => {
    togglePreview(comment);
    setShowConversationPanel(true);
    setSelectedComment(addStampImageToPinComments(comment));
  };

  const clearPreviousPreview = (comment) => {
    setShowDashboardPreviewModal(false);
    setSelectedPreview(comment.document);
    setConversationPreview(comment.conversation);
  };

  const togglePreview = async (comment) => {
    await clearPreviousPreview(comment);
    setShowDashboardPreviewModal(true);
    setSelectedComment(addStampImageToPinComments(comment));
  };

  const addCommentStampImage = (xfdfHighlightString) => {
    let stampImageTag;
    const regexOne = /<imagedata><\/imagedata>/;
    const regexTwo = /<imagedata\/>/;

    if (xfdfHighlightString.match(regexOne)) {
      stampImageTag = /<imagedata><\/imagedata>/;
    } else if (xfdfHighlightString.match(regexTwo)) {
      stampImageTag = /<imagedata\/>/;
    }

    const xfdfWithStampImages = xfdfHighlightString.replace(
      stampImageTag,
      "<imagedata>data:image/svg+xml;base64,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</imagedata>"
    );

    return xfdfWithStampImages;
  };

  const addStampImageToPinComments = (comment) => {
    let conversationWithStamps;

    if (comment.conversation.xfdf_highlight_string) {
      comment.conversation.xfdf_highlight_string = addCommentStampImage(
        comment.conversation.xfdf_highlight_string
      );
      conversationWithStamps = comment;
    } else {
      conversationWithStamps = comment;
    }
    return conversationWithStamps;
  };

  const renderCommentCard = () => {
    if (showLoader) {
      return (
        <div className={styles.loaderContainer}>
          <Lottie options={defaultOptions} height={92} width={82} />
        </div>
      );
    } else {
      return comments.map((comment, index) => {
        if (comment && comment.document) {
          return (
            <CSSTransition
              in={dismissed !== elRefs[index]}
              nodeRef={elRefs[index]}
              timeout={300}
              classNames="my-node"
              unmountOnExit
            >
              <div ref={elRefs[index]} className={styles.cardContainer}>
                <h3 className={styles.documentTitle}>
                  <div className={styles.documentTitleSubContainer}>
                    {comment.comment_has_notifications && (
                      <img
                        className={styles.notificationIndicator}
                        src={notificationIndicator}
                      />
                    )}
                    {comment.document.title}
                  </div>
                  <img
                    className={styles.closeButton}
                    onClick={() =>
                      dismissConversation(comment.conversation, index)
                    }
                    src={close}
                  />
                </h3>
                <p className={styles.commentBody}>
                  {formatMentions(comment.body)}
                </p>
                <div className={styles.commenterName}>
                  {comment.commenter_name}
                  <div className={styles.dotSeparator}>&#9679;</div>
                  {moment(comment.created_at).calendar(null, {
                    lastDay: "[Yesterday]",
                    lastWeek: "MMM D, YYYY",
                    sameDay: "LT",
                    sameElse: "MMM D, YYYY",
                  })}
                </div>
                <div className={styles.actionsContainer}>
                  <a
                    className={styles.actionButton}
                    onClick={(e) => {
                      togglePreview(comment);
                    }}
                  >
                    Preview
                  </a>
                  <a
                    className={styles.actionButton}
                    onClick={() => replyInConversation(comment)}
                  >
                    Reply
                  </a>
                  <a
                    className={styles.actionButton}
                    onClick={() =>
                      toggleConversationStatus(comment.conversation, index)
                    }
                  >
                    Resolve
                  </a>
                </div>
              </div>
            </CSSTransition>
          );
        }
      });
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <div className={styles.container}>{renderCommentCard()}</div>;
};
